import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// 添加Tailwind配置
import { createTheme } from './theme';
createTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 